export enum BrandCampaignPostsFiltersOrderBy {
  Date = "DATE",
  AdImpressions = "AD_IMPRESSIONS",
  AdReach = "AD_REACH",
  AdEngagement = "AD_ENGAGEMENT",
  AdClicks = "AD_CLICKS",
  PostLikes = "POST_LIKES",
  PostComments = "POST_COMMENTS",
  PostShares = "POST_SHARES",
  PostLinkClicks = "POST_LINK_CLICKS",
  PostViews = "POST_VIEWS",
}
